<template>
  <div class="desktop-layout">
    <div class="desktop-header desktop-container"><desktop-header /></div>
    <div class="desktop-nav">
      <desktop-nav />
    </div>
    <div class="desktop-main">
      <slot></slot>
    </div>
    <div class="desktop-footer">
      <div class="desktop-container"><desktop-footer /></div>
    </div>
  </div>
</template>
<script>
import DesktopNav from "./DesktopNav.vue";
import DesktopHeader from "./DesktopHeader.vue";
import DesktopFooter from "./DesktopFooter.vue";
export default {
  components: {
    DesktopNav,
    DesktopHeader,
    DesktopFooter,
  },
};
</script>
<style lang="scss" scoped>
.desktop-layout {
  min-width: 1280px;

  .desktop-header {
    height: 86px;
  }

  .desktop-nav {
    position: relative;
    height: 97px;
    background-color: #3468fb;
  }

  .desktop-main {
    min-height: calc(100vh - 330px); // 330px=header+nav+footer
    padding-top: 27px;
    background-color: #f2f5fe;
  }

  .desktop-footer {
    height: 120px;
    background-color: #000;
  }
}
</style>
// PC端全局样式
<style lang="scss">
.desktop-container {
  width: 1200px;
  margin-right: auto;
  margin-left: auto;
}
</style>
